import instance from "@/utils/require.js"

// 首页--操作排行
export function apiTopListAction(data = {}) {
	return instance({
		url: "/aim/api/v3/top_list/action",
		method: "post",
		data
	})
}

// 首页--登录排行
export function apiTopListLogin(data = {}) {
	return instance({
		url: "/aim/api/v3/top_list/login",
		method: "post",
		data
	})
}